import { render, staticRenderFns } from "./ContMyDatasets.vue?vue&type=template&id=20de51e2&scoped=true&lang=pug"
import script from "./ContMyDatasets.vue?vue&type=script&lang=js"
export * from "./ContMyDatasets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20de51e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20de51e2')) {
      api.createRecord('20de51e2', component.options)
    } else {
      api.reload('20de51e2', component.options)
    }
    module.hot.accept("./ContMyDatasets.vue?vue&type=template&id=20de51e2&scoped=true&lang=pug", function () {
      api.rerender('20de51e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/refactoring/ContMyDatasets.vue"
export default component.exports